import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {EventsEmitterService} from './emitter.service';
import {LogService} from './log.service';
import {SecurityService} from './security.service';

@Injectable()
export class LedgerService extends SecurityService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  public changeDemand(params: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Basic YWRtaW46YWRtaW4=',
    });
    let options = {headers};

    let serviceUrl = this.fabricApiUrl + 'api/invoke';

    let request: any = {};
    let blockchain_details = this.getFromStorageAsJSON('blockchain_details', false);
    /* request.username = "revdeb1";//blockchain_details.username;
        request.secret = "YdfHhdrWVnHV4";//blockchain_details.password;
        request.usertype = "DEBTOR";//blockchain_details.userType; */
    request.username = 'myname2'; //blockchain_details.username;
    request.secret = 'LXuHKWCCdzlO9'; //blockchain_details.password;
    request.usertype = 'FACTORING'; //blockchain_details.userType;
    request.channel = this.configService.getChannel();
    request.chaincode = 'demoFactoring';
    request.method = 'changeDemand';
    request.args = [params.key, params.changeStatus];

    return this.http.post(serviceUrl, request, options).pipe(
      map((x: HttpResponse<any>) => this.extractData(x)),
      catchError(this.handleError),
    );
  }

  createDemand(params: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Basic YWRtaW46YWRtaW4=',
    });
    let options = {headers};

    let serviceUrl = this.fabricApiUrl + 'api/invoke';

    let request: any = {};
    let blockchain_details = this.getFromStorageAsJSON('blockchain_details', false);
    request.username = 'client1234'; //blockchain_details.username;
    request.secret = 'LrbALAWQObND2'; //blockchain_details.password;
    request.usertype = 'CLIENT'; //blockchain_details.userType;
    request.channel = this.configService.getChannel();
    request.chaincode = 'demoFactoring';
    request.method = 'createDemand';
    request.args = [];
    request.args.push(JSON.stringify(params));

    return this.http.post(serviceUrl, request, options).pipe(
      map((x: HttpResponse<any>) => this.extractData(x)),
      catchError(this.handleError),
    );
  }

  disputeDemandsTermsChanged(params: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Basic YWRtaW46YWRtaW4=',
      }),
    };

    let serviceUrl = this.fabricApiUrl + 'api/invoke';

    let request: any = {};
    let blockchain_details = this.getFromStorageAsJSON('blockchain_details', false);
    request.username = 'revdeb1'; //blockchain_details.username;
    request.secret = 'YdfHhdrWVnHV4'; //blockchain_details.password;
    request.usertype = 'DEBTOR'; //blockchain_details.userType;
    request.channel = this.configService.getChannel();
    request.chaincode = 'demoFactoring';
    request.method = 'disputeDemandTermsChanged';
    request.args = [];

    params.nAmnt = params.nAmnt || params.amnt;
    params.nTerms = params.nTerms || '';

    request.args.push(params.key, 'disputed with changed terms', params.nAmnt, params.nTerms);

    console.log(request);

    return this.http.post(serviceUrl, request, options).pipe(
      map((x: HttpResponse<any>) => this.extractData(x)),
      catchError(this.handleError),
    );
  }
}
